document.querySelectorAll('.header-wrapper').forEach(header => {
  header.addEventListener('mouseenter', () => {
    document.querySelectorAll('.mega-menu').forEach(megaMenu => {
      megaMenu.addEventListener('mouseenter', () => {
        megaMenu.setAttribute('open', true);
        // 他のメガメニューのopen属性を削除
        document.querySelectorAll('.mega-menu').forEach(otherMenu => {
          if (otherMenu !== megaMenu) {
            otherMenu.removeAttribute('open');
          }
        });
      });
    });
  });
  header.addEventListener('mouseleave', () => {
    document.querySelectorAll('.mega-menu').forEach(megaMenu => {
      megaMenu.removeAttribute('open');
    });
  });
});

// 追加: メニュー項目クリック時の処理
document.querySelectorAll('.mega-menu summary').forEach(summary => {
  summary.addEventListener('click', event => {
    const href = event.currentTarget.getAttribute('data-href');
    if (href) {
      window.location.href = href;
    }
  });
});

/* 追加: サブメニューのアイコン表示 */
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.menu-drawer__menu-item summary').forEach((summary) => {
        summary.addEventListener('click', (event) => {
            // サブメニューの開閉
            const details = summary.parentElement; // 親の<details>要素を取得
            details.open = !details.open; // 状態をトグル

            // アイコンの表示切替
            const toggleIcon = summary.querySelector('.menu-drawer__toggle-icon');
            const plusIcon = toggleIcon.querySelector('.icon-plus');
            const minusIcon = toggleIcon.querySelector('.icon-minus');

            if (details.open) {
                plusIcon.style.display = 'none';
                minusIcon.style.display = 'inline';
            } else {
                plusIcon.style.display = 'inline';
                minusIcon.style.display = 'none';
            }
        });
    });
});
